// removed by extract-text-webpack-plugin
module.exports = {"default":"src-styles----container-module---default---2dBmj src-styles----clearfix-module---clearfix---uzoKd"};


//////////////////
// WEBPACK FOOTER
// ./src/styles/container.module.css
// module id = 50
// module chunks = 28901507966785 35783957827783 114276838955818